import { newE2EPage } from "@stencil/core/testing";

describe("async-modal", () => {
    it("should render the component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-async-modal/>`);
        const el = await page.find("ux-async-modal");
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-async-modal src="test"></ux-async-modal>`);
        await page.waitForChanges();
        const el = await page.find("ux-async-modal");
        expect(el).toMatchSnapshot();
    });

    it("should match to snapshot with content", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-async-modal opened src="./mock-data/async-modal.html" />`);
        await page.waitForChanges();
        const el = await page.find("ux-async-modal");
        expect(el).toMatchSnapshot();
    });
});
